import React from 'react';
import {
	REQUIRED_ERROR,
	EMPTY_FIELDS_ERROR,
	PDF_REQUIREMENT_ERROR,
	FIX_INVALID_ERROR,
	NETWORK_ERROR,
	DUPLICATE_ERROR,
	INVALID_EXT_ERROR,
	INVALID_CHARS_ERROR,
	FILE_NAME_TOO_LONG_ERROR,
	FILE_NAME_TOO_SHORT_ERROR,
	TOO_LARGE_ERROR,
	INVALID_EMAIL_ERROR,
	INVALID_ADDITIONAL_EMAIL_ERROR,
	INVALID_DATE_ERROR,
	FILE_REQUIREMENT_ERROR,
	INVALID_NUMBER_ERROR,
	DUPLICATE_DOCKET_NUM_ERROR,
	INVALID_PHONE_NUMBER_ERROR,
	INVALID_FAX_NUMBER_ERROR,
	getMaxFieldLengthError,
	PDF_EXTENSION_ERROR,
	NUMBER_OUT_OF_RANGE,
	INVALID_PRIMARY_RECORDATION_FORMAT_ERROR
 } from '../../../resources/constants/errors';
import {
	PDF_CAPS,
	VALID_EFILING_FILE_TYPES,
	MAX_FILE_SIZE_BYTES,
	INFORMAL_FIELDS_TO_VALIDATE,
	EFILING_FIELDS_TO_VALIDATE,
	RECORDATION_FIELDS_TO_VALIDATE,
	IS_IE11,
	FILE_MIME_TYPES,
	FIELDS_TO_VALIDATE_IS_NUMBER,
	MAX_FILE_NAME_LENGTH,
	hasValue,
	MAX_EQUIPMENT_DESCRIPTION_LENGTH,
	RCPA_FIELDS_TO_VALIDATE,
	PHONE_FIELDS,
	ENVIRONMENTAL_COMMENTS_FIELDS_TO_VALIDATE,
	VALID_EFILING_ENV_COMM_FILE_TYPES,
	MAX_FILE_SIZE_500MB_BYTES,
	VALID_EFILING_FORMAL_FILE_TYPES
 } from '../../../resources/constants/validations';
import { NETWORK_ERROR_ID, ATTACHMENTS_DIV_ID } from '../../../resources/constants/ui';
import {
	PARTY_FIELDS_REQUIRED,
	EMAIL_FIELD,
	ADDITIONAL_EMAIL_FIELD,
	ATTACHMENT_FIELD,
	FORMAL_FILING_FORM_TYPE,
	OTHER_FILING_FORM_TYPE,
	RECORDATION_FORM_TYPE,
	CONFIRMATION_NUM_FIELD,
	RECORDATION_OPTIONS,
	PRIMARY_RECORDATION_NUM_FIELD,
	DOCKET_NUMBERS_FIELD,
	SEQUENCE_NUM_FIELD,
	DOCKET_NUM_FIELDS,
	DOCKET_NUM_FIELD,
	PHONE_FIELD,
	FAX_FIELD,
	EQUIPMENT_DESCRIPTION_FIELD,
	PARTY_FIELDS,
	OTHER_PARTY_TYPE_FIELD,
	PARTY_TYPE_FIELD,
	RCPA_FORM_TYPE,
	ENVIRONMENTAL_COMMENTS_FORM_TYPE,
	EFILING_SUBMIT_CHECKBOX_FIELD
 } from '../../../resources/constants/fields';
import { FEE_OPTIONS, OTHER_PARTY_TYPE } from '../../../resources/constants/dropdowns';
import { isCorrectDateFormat, checkDateContinuity } from '../../../resources/util/dateUtil';

export const getErrors = ({errors, networkErrors}) => {
	if(errors.length) {
		let displayErrors = [];
		errors.map(error => {
			if (error.errorMsg === REQUIRED_ERROR) {
				if (!displayErrors.includes(EMPTY_FIELDS_ERROR)) {
					displayErrors.push(EMPTY_FIELDS_ERROR);
				}
			} else if (
				error.errorMsg.toUpperCase().includes(PDF_CAPS) &&
				!displayErrors.includes(PDF_REQUIREMENT_ERROR)
			) {
				displayErrors.push(PDF_REQUIREMENT_ERROR);
			} else if (
				error.errorMsg.includes(FILE_REQUIREMENT_ERROR) &&
				!displayErrors.includes(FILE_REQUIREMENT_ERROR)
			) {
				displayErrors.push(FILE_REQUIREMENT_ERROR);
			} else if (!displayErrors.includes(FIX_INVALID_ERROR)) {
				//adds invalid msg if error is not an empty field or network error
				displayErrors.push(FIX_INVALID_ERROR);
			}
			return true;
		});
		return (
			<React.Fragment>
				{displayErrors.join(', ')}
			</React.Fragment>
		);
	} else if(networkErrors.length) {
		return (
			<p key={NETWORK_ERROR_ID} className={"shortLine"}>
				{NETWORK_ERROR}
			</p>
		);
	}
};

export const getFieldError = (errors, fieldId, idx) => {
	if(hasValue(idx)) {
		return errors
		.filter(
			error =>
				(error.fieldId === `${fieldId}-${idx}` &&
				error.errorMsg !== REQUIRED_ERROR)
		)
		.reduce(
			(acc, cur) => [...acc, cur.errorMsg + "\n"],
			[]
		)
	}
	else{
		return errors
		.filter(
			error =>
				(error.fieldId === fieldId &&
				error.errorMsg !== REQUIRED_ERROR)
		)
		.reduce(
			(acc, cur) => [...acc, cur.errorMsg + "\n"],
			[]
		)
	}
}

export const clearFieldError = (state, fieldId) => {
	let newState = {...state};
	newState.form.errors = newState.form.errors.filter(error => {
		return !error.fieldId.includes(fieldId);
	});
	return newState;
}

export const validateDateField = (state, field) => {
	let newState = {...state};
	let element = document.getElementsByName(field)[0];
	if(element) {
		if(IS_IE11) {
			if(state.data[field] && isCorrectDateFormat(state.data[field]) && checkDateContinuity(state.data[field])) {
				element.classList.remove("date-invalid");
				newState = clearFieldError(newState, field);
			} else {
				element.classList.add("date-invalid");
				newState = clearFieldError(newState, field);
				newState.form.errors.push(
					{
						errorMsg: INVALID_DATE_ERROR,
						fieldId: field
					}
				)
			}
		} else {
			if(!state.data[field] || !isCorrectDateFormat(state.data[field]) || !element.checkValidity()) {
				element.classList.add("date-invalid");
				newState = clearFieldError(newState, field);
				newState.form.errors.push(
					{
						errorMsg: INVALID_DATE_ERROR,
						fieldId: field
					}
				)
			} else {
				element.classList.remove("date-invalid");
				newState = clearFieldError(newState, field);
			}
		}
	}
	return newState;
}

export const isValidPrimaryRecordationFormat = (recordationString) =>{
	return /^[a-zA-Z0-9]+$/.test(recordationString);
}

export const validateRecordationNumField = (state, field) => {
	let newState = {...state};
	let element = document.getElementsByName(field)[0];
	if (element){
		if (!isValidPrimaryRecordationFormat(state.data[field])) {
			element.classList.add("date-invalid");
			newState = clearFieldError(newState, field);
			newState.form.errors.push(
				{
					errorMsg: INVALID_PRIMARY_RECORDATION_FORMAT_ERROR,
					fieldId: field
				}
			)
		} else {
			element.classList.remove("date-invalid");
			newState = clearFieldError(newState, field);
		}
	}
	return newState;
}

export const validateFilingByType = (state) => {
	let fieldsToValidate = [];
	switch(state.form.type) {

		case FORMAL_FILING_FORM_TYPE:
			fieldsToValidate = [...EFILING_FIELDS_TO_VALIDATE];
			let confirmationNotRequired = state.data.feeOption === FEE_OPTIONS[2].value;
			if (confirmationNotRequired) {
				fieldsToValidate = EFILING_FIELDS_TO_VALIDATE.filter(
					field => field !== CONFIRMATION_NUM_FIELD
				);
			}
			return [
				...validateForm(state, fieldsToValidate),
				...validateAllParties(state.form, state.data.parties, true),
				...validatePDF(state),
				...validateAllFiles(state.form.errors, state.data.attachments, FORMAL_FILING_FORM_TYPE),
				...validateEFilingSubmitCheckbox(state)
			];

		case OTHER_FILING_FORM_TYPE:
			return [
				...validateForm(state, INFORMAL_FIELDS_TO_VALIDATE),
				...validateAllParties(state.form, state.data.parties, true),
				...validatePDF(state),
				...validateAllFiles(state.form.errors, state.data.attachments),
				...validateEFilingSubmitCheckbox(state)
			];

		case RECORDATION_FORM_TYPE:
			fieldsToValidate = [...RECORDATION_FIELDS_TO_VALIDATE];
			let isPrimaryRecordation = state.data.recordationOption === RECORDATION_OPTIONS[0].value;
			if (isPrimaryRecordation) {
				fieldsToValidate = RECORDATION_FIELDS_TO_VALIDATE.filter(
					field => field !== PRIMARY_RECORDATION_NUM_FIELD
				);
			}
			return [
				...validateForm(state, fieldsToValidate),
				...validateAllParties(state.form, state.data.parties, true),
				...validateHasFile(state),
				...validateAllFiles(state.form.errors, state.data.attachments),
				...validateEFilingSubmitCheckbox(state)
			];

		case RCPA_FORM_TYPE:
			return [
				...validateForm(state, RCPA_FIELDS_TO_VALIDATE),
				...validateAllFiles(state.form.errors, state.data.attachments)
			];
		case ENVIRONMENTAL_COMMENTS_FORM_TYPE:
			return [
				...validateForm(state, ENVIRONMENTAL_COMMENTS_FIELDS_TO_VALIDATE),
				...validateAllFiles(state.form.errors, state.data.attachments, ENVIRONMENTAL_COMMENTS_FORM_TYPE),
				...validateEFilingSubmitCheckbox(state)
			];
		default:
			return [];
	}
}

export const validateForm = (state, formFields) => {
	let errors = [...state.form.errors];

	formFields.forEach(field => {
		var fieldValue = state.data[field];
		if (!hasValue(fieldValue)) {
			errors.push(
				{
					errorMsg: REQUIRED_ERROR,
					fieldId: field
				}
			);
		} else if(FIELDS_TO_VALIDATE_IS_NUMBER.includes(field)) {
			if (!isNumber(fieldValue)) {
				errors.push(
					{
						errorMsg: INVALID_NUMBER_ERROR,
						fieldId: field
					}
				);
			} else if(hasValue(fieldValue) && !isNumberInRange(fieldValue)) {
				errors.push(
					{
						errorMsg: NUMBER_OUT_OF_RANGE,
						fieldId: field
					}
				);
			}
		} else if(PHONE_FIELDS.includes(field)) {
			if(!validatePhoneNumber(fieldValue)) {
				switch(field) {
					case PHONE_FIELD:
						errors.push(
							{
								errorMsg: INVALID_PHONE_NUMBER_ERROR,
								fieldId: field
							}
						);
						break;
					case FAX_FIELD:
						errors.push(
							{
								errorMsg: INVALID_FAX_NUMBER_ERROR,
								fieldId: field
							}
						);
						break;
					default:
						break;
				}
			}
		} else if(field === EQUIPMENT_DESCRIPTION_FIELD && !validateFieldLength(fieldValue, MAX_EQUIPMENT_DESCRIPTION_LENGTH)) {
			errors.push(
				{
					errorMsg: getMaxFieldLengthError(MAX_EQUIPMENT_DESCRIPTION_LENGTH, String(fieldValue).length),
					fieldId: field
				}
			);
		}
	});
	if(DOCKET_NUMBERS_FIELD in state.data) {
		let validateData = {docketNumbers: state.data.docketNumbers, errors: [...errors]};
		errors = validateDocketNumbers(validateData, true);
	}
	return errors;
};

export const validatePDF = state => {
	let havePdf = false;
	let errors = [];
	for (var i = 0; i < state.data.attachments.length; i++) {
		if (
			validateFileExtension(state.data.attachments[i].state.file, ["pdf"]) ===
			true
		) {
			havePdf = true;
			break;
		}
	}
	if (havePdf === false) {
		errors.push({
			errorMsg: PDF_REQUIREMENT_ERROR,
			fieldId: ATTACHMENTS_DIV_ID
		});
	}
	return errors;
};

export const validateHasFile = state => {
	let haveFile = false;
	let errors = [];
	for (var i = 0; i < state.data.attachments.length; i++) {
		let file = state.data.attachments[i].state.file;
		if (
			hasValue(file) &&
			hasValue(file.name)
		) {
			haveFile = true;
			break;
		}
	}
	if (haveFile === false) {
		errors.push({
			errorMsg: FILE_REQUIREMENT_ERROR,
			fieldId: ATTACHMENTS_DIV_ID
		});
	}
	return errors;
};

export const listValidExtensions = (formType) => {
	switch(formType){
		case ENVIRONMENTAL_COMMENTS_FORM_TYPE:
			return VALID_EFILING_ENV_COMM_FILE_TYPES;
		case FORMAL_FILING_FORM_TYPE:
			return VALID_EFILING_FORMAL_FILE_TYPES;
		default:
			return VALID_EFILING_FILE_TYPES;
	}
};

export const validateFile = (file, fieldId, errorArr, attachmentArr, validatePdf, formType) => {
	let index = fieldId.substring(fieldId.lastIndexOf("-") + 1);
	// Clear out all errors for this field first
	let errors = errorArr.filter(
		error =>
			error.fieldId !== fieldId && error.fieldId !== ATTACHMENTS_DIV_ID
	);
	// Then add errors if any validations fail
	if (hasValue(file)) {
		let files = attachmentArr.reduce(
			(acc, cur) => [...acc, cur.state.file],
			[]
		);
		let newArr = files.slice(0, index);
		let newArr2 = files.slice(index + 1, files.length);
		files = [...newArr, ...newArr2];
		let fileNameValidation = validateFileNameLength(file);
		if (validateFileUniqueness(file, files) === false) {
			errors = [
				...errors,
				{
					errorMsg: DUPLICATE_ERROR,
					fieldId: fieldId,
					targetValue: file.name
				}
			];
		}
		if(validatePdf) {
			if (validateFileExtension(file, ["pdf"]) === false) {
				errors = [
					...errors,
					{
						errorMsg: PDF_EXTENSION_ERROR,
						fieldId: fieldId,
						targetValue: file.name
					}
				];
			}
		} else {
			if (validateFileExtension(
					file,
					listValidExtensions(formType)
					) === false
				) {
				errors = [
					...errors,
					{
						errorMsg: INVALID_EXT_ERROR,
						fieldId: fieldId,
						targetValue: file.name
					}
				];
			}
		}
		if (validateFileNameContents(file) === false) {
			errors = [
				...errors,
				{
					errorMsg: INVALID_CHARS_ERROR,
					fieldId: fieldId,
					targetValue: file.name
				}
			];
		}
		if (fileNameValidation === 1) {
			errors = [
				...errors,
				{
					errorMsg: FILE_NAME_TOO_LONG_ERROR,
					fieldId: fieldId,
					targetValue: file.name
				}
			];
		} else if (fileNameValidation === -1) {
			errors = [
				...errors,
				{
					errorMsg: FILE_NAME_TOO_SHORT_ERROR,
					fieldId: fieldId,
					targetValue: file.name
				}
			];
		}
		if (validateFileSize(file, formType) === false) {
			errors = [
				...errors,
				{
					errorMsg: TOO_LARGE_ERROR,
					fieldId: fieldId,
					targetValue: file.name
				}
			];
		}
	}
	return errors;
};

const getRequiredPartyFields = (type, party) => {
	if(party.state[PARTY_TYPE_FIELD] === OTHER_PARTY_TYPE) {
		return [...PARTY_FIELDS_REQUIRED[type], OTHER_PARTY_TYPE_FIELD];
	} else {
		return PARTY_FIELDS_REQUIRED[type];
	}
} 

export const validateAllParties = (form, partyArr, checkRequired) => {
	// Clear out ALL party errors, as we will be re-evaluating all parties below
	let errors = form.errors.filter(
		error =>
			!PARTY_FIELDS.some(element =>
				error.fieldId.includes(element)
			)
	);
	
	// Then add errors if any validations fail
	partyArr.forEach((party, i) => {
		let requiredFields = getRequiredPartyFields(form.type, party);
		for(var field in party.state) {
			let value = party.state[field];
			if (!hasValue(value)) {
				if (
					checkRequired &&
					requiredFields.includes(field)
				) {
					errors.push(
						{
							errorMsg: REQUIRED_ERROR,
							fieldId: `${field}-${i}`
						}
					);
				}
			} else if (
				field === PHONE_FIELD &&
				!validatePhoneNumber(value)
			) {
				errors.push(
					{
						errorMsg: INVALID_PHONE_NUMBER_ERROR,
						fieldId: `${PHONE_FIELD}-${i}`
					}
				);
			} else if (
				field === FAX_FIELD &&
				!validatePhoneNumber(value)
			) {
				errors.push(
					{
						errorMsg: INVALID_FAX_NUMBER_ERROR,
						fieldId: `${FAX_FIELD}-${i}`
					}
				);
			} else if (field === EMAIL_FIELD) {
				if (validateEmail(value) === false) {
					errors.push(
						{
							errorMsg: INVALID_EMAIL_ERROR,
							fieldId: `${EMAIL_FIELD}-${i}`
						}
					);
				}
			} else if (field === ADDITIONAL_EMAIL_FIELD) {
				value.forEach((email, index) => {
					if (!hasValue(email)) {
						if(checkRequired) {
							errors.push(
								{
									errorMsg: REQUIRED_ERROR,
									fieldId: `${ADDITIONAL_EMAIL_FIELD}-${i}-${index}`
								}
							);
						}
					} else if (validateEmail(email) === false) {
						errors.push(
							{
								errorMsg: INVALID_ADDITIONAL_EMAIL_ERROR,
								fieldId: `${ADDITIONAL_EMAIL_FIELD}-${i}-${index}`
							}
						);
					}
				});
			}
		}
	});
	return errors;
};

export const validateAllFiles = (errorArr, attachments, formType) => {
	// Clear out ALL file errors, as we will be reevaluating all files below
	let errors = errorArr.filter(
		error =>
			!error.fieldId.includes(ATTACHMENT_FIELD) &&
			error.fieldId !== ATTACHMENTS_DIV_ID
	);
	// Then add errors if any validations fail
	for (var i = 0; i < attachments.length; i++) {
		let fieldId = `${ATTACHMENT_FIELD}-${i}`;
		let file = attachments[i].state.file;
		if (hasValue(file)) {
			let files = attachments.reduce(
				(acc, cur) => [...acc, cur.state.file],
				[]
			);
			let newArr = files.slice(0, i + 1);
			let newArr2 = files.slice(i + 1, files.length);
			newArr.pop();
			files = [...newArr, ...newArr2];
			let fileNameValidation = validateFileNameLength(file);
			if (validateFileUniqueness(file, files) === false) {
				errors.push(
					{
						errorMsg: DUPLICATE_ERROR,
						fieldId: fieldId,
						targetValue: file.name
					}
				);
				continue;
			}
			if (validateFileExtension(
					file,
					listValidExtensions(formType)
				) === false
			) {
				errors.push(
					{
						errorMsg: INVALID_EXT_ERROR,
						fieldId: fieldId,
						targetValue: file.name
					}
				);
				continue;
			}
			if (validateFileNameContents(file) === false) {
				errors.push(
					{
						errorMsg: INVALID_CHARS_ERROR,
						fieldId: fieldId,
						targetValue: file.name
					}
				);
				continue;
			}
			if (fileNameValidation === 1) {
			errors.push(
				{
					errorMsg: FILE_NAME_TOO_LONG_ERROR,
					fieldId: fieldId,
					targetValue: file.name
				}
			);
			continue;

		} else if (fileNameValidation === -1) {
			errors.push(
				{
					errorMsg: FILE_NAME_TOO_SHORT_ERROR,
					fieldId: fieldId,
					targetValue: file.name
				}
			);
			continue;
		}
			if (validateFileSize(file, formType) === false) {
				errors.push(
					{
						errorMsg: TOO_LARGE_ERROR,
						fieldId: fieldId,
						targetValue: file.name
					}
				);
				continue;
			}
		}
	}
	return errors;
};

export const isNumber = (value) => {
	if(value) {
		let stringValue = String(value);
		for(var index in stringValue) {
			if(stringValue[index] < "0" || stringValue[index] > "9") {
				return false;
			}
		}
	}
	return true;
}

export const isNumberInRange = (value, min, max) => {
	if(value) {
		let minValue = Number(min ?? 0);
		let maxValue = Number(max ?? 2147483647);
		let numberValue = Number(value);
		return (minValue <= numberValue) && (numberValue <= maxValue);
	}
	return false;
}

export const validatePhoneNumber = phone => {
	if(phone) {
		let stringValue = String(phone);
		for(var index in stringValue) {
			if(stringValue[index] !== '-' && (stringValue[index] < "0" || stringValue[index] > "9")) {
				return false;
			}
		}
	}
	return true;
}

export function validateEmail(email) {
	const validEmailPattern = /^\w+(?:[.-]\w+)*@\w+(?:[.-]\w+)*(?:\.\w{2,3})+$/;
	return (hasValue(email) && validEmailPattern.test(email));
}

export function validateDocketNumbers(state, checkRequired) {

	var errors = state.errors.filter(error => { 
		var errorField = error.fieldId.split("-")[0];
		var filterOutDocketNumErrors = !DOCKET_NUM_FIELDS.includes(errorField) && DOCKET_NUM_FIELD !== errorField;
		return filterOutDocketNumErrors;
	});

	var fieldsToValidateNumber = DOCKET_NUM_FIELDS.filter(docketNumField => FIELDS_TO_VALIDATE_IS_NUMBER.includes(docketNumField));

	state.docketNumbers.forEach((docketNumber, index) => {

		if(docketNumber[SEQUENCE_NUM_FIELD]) {
			errors = checkDuplicateDocketNums(docketNumber, index, state.docketNumbers, errors);
		}

		fieldsToValidateNumber.forEach(field => {

			if(field === SEQUENCE_NUM_FIELD &&
				!hasValue(docketNumber[field]) &&
				checkRequired
			) {
				errors.push(
					{
						errorMsg: REQUIRED_ERROR,
						fieldId: `${field}-${index}`
					}
				);
			}
			if(!isNumber(docketNumber[field])) {
				errors.push(
					{
						errorMsg: INVALID_NUMBER_ERROR,
						fieldId: `${field}-${index}`
					}
				);
			} else if(hasValue(docketNumber[field]) && !isNumberInRange(docketNumber[field])) {
				errors.push(
					{
						errorMsg: NUMBER_OUT_OF_RANGE,
						fieldId: `${field}-${index}`
					}
				);
			}
		})
	})
	return errors;
}

const checkDuplicateDocketNums = (curentDocketNumber, currentIndex, allDocketNumbers, errors) => {
	var newErrors = [...errors];
	allDocketNumbers.forEach((otherDocketNumber, otherIndex) => {
		var isAfter = currentIndex < otherIndex;
		if(isAfter) {
			var matchedFields = [];

			for(const fieldName in curentDocketNumber) {
				if(curentDocketNumber[fieldName] === otherDocketNumber[fieldName]) {
					matchedFields.push(fieldName);
				}
			}
			
			if(matchedFields.length === DOCKET_NUM_FIELDS.length) {
				newErrors.push(
					{
						errorMsg: DUPLICATE_DOCKET_NUM_ERROR,
						fieldId: `${DOCKET_NUM_FIELD}-${otherIndex}`
					}
				);
				
			}
		}
	});
	
	return newErrors;
}

export function validateFileExtension(file, validExtensions) {
	if (
		hasValue(file) &&
		hasValue(file.name)
	) {
		var isValid = false;
		var extPos = file.name.lastIndexOf(".") + 1;
		for (var f = 0; f < validExtensions.length; f++) {
			var ext = validExtensions[f];
			if (
				extPos > 0 &&
				file.name.substring(extPos).toLowerCase() === ext.toLowerCase()
			) {
				isValid = true;
				break;
			}
		}
		return isValid;
	}
	return false;
}

export function validateFieldLength(value, length) {
	if(String(value).length <= length) {
		return true;
	}
	return false;
}

// File validations...
export function validateFileNameLength(file) {
	if(hasValue(file) && hasValue(file.name)) {
		if(file.name.length > MAX_FILE_NAME_LENGTH) {
			return 1;
		} else if(file.name.length <= MAX_FILE_NAME_LENGTH && file.name.length > 0) {
			return 0;
		}
	}
	return -1;
}

export function validateFileNameContents(file) {
	return (
		hasValue(file) &&
		hasValue(file.name) &&
		!file.name.substring(0,file.name.lastIndexOf(".")).match("[^0-9A-Za-z_]+")
	);
}

export function validateFileSize(file, formType) {
	return (
		hasValue(file) &&
		hasValue(file.name) &&
		file.size <= determineMaxFileSize(formType)
	);
}

export function determineMaxFileSize(formType) {
	switch(formType){
		case FORMAL_FILING_FORM_TYPE:
		case ENVIRONMENTAL_COMMENTS_FORM_TYPE:
			return MAX_FILE_SIZE_500MB_BYTES;
		default:
			return MAX_FILE_SIZE_BYTES;
	}
}

export function validateFileUniqueness(file, files) {
	for (var i = 0; i < files.length; i++) {
		if (files[i] === undefined || files[i] === null || files[i] === "") {
			continue;
		}
		if (hasValue(files[i]) && files[i].name.toUpperCase() === file.name.toUpperCase()) {
			return false;
		}
	}
	return true;
}

// Functionality taken from:
//   https://medium.com/the-everyday-developer/detect-file-mime-type-using-magic-numbers-and-javascript-16bc513d4e1e
//   still needs some work...
export function validateFileMimeType(file, expectedFileType) {
	console.log("MIME type validation start");
	let mimeCheck = [];

	const fileReader = new FileReader();
	fileReader.onloadend = e => {
		if (e.target.readyState === FileReader.DONE) {
			// slice the file according to current MIME type byteLength

			// Create TypedArray to store the file bytes properly
			let uint = new Uint8Array(e.target.result);
			let bytes = [];
			// Transform each byte into its hexadecimal representation
			uint.forEach(byte => {
				bytes.push(byte.toString(16));
			});
			// Turn our hexadecimal array back into a single string.
			//   This is our file's MIME type
			const hex = bytes.join("").toUpperCase();
			mimeCheck.push({
				byteLength: uint.length,
				signature: hex
			});
		}
	};

	// Get list of MIME types that could be associated with the expected file type
	const mimeTypes = FILE_MIME_TYPES.filter(m =>
		m.fileTypes.includes(expectedFileType.toString())
	);
	console.log(`Matching MIME types for file extension ${expectedFileType}:`);
	console.log(mimeTypes);
	// Check if file signature matches any of the possible MIME types
	mimeTypes
		.forEach(m => {
			console.log("Current MIME type:");
			console.log(m);
			var fileSlice = file.slice(0, m.byteLength);
			console.log("File Slice per MIME type byteLength:");
			console.log(fileSlice);
			fileReader.readAsArrayBuffer(fileSlice);
		})
		.then(() => {
			mimeTypes.forEach((m, idx) => {
				console.log("Current MIME type:");
				console.log(m);
				let hex = mimeCheck[idx].signature;
				console.log("Actual file signature:");
				console.log(hex);

				if (hex === m.signature) {
					console.log("File signature matches! Quitting...");
					return true;
				} else {
					console.log("File signature did not match. Continuing...");
				}
			});
		});
	console.log("No matches found!");
	return false;
}

export const validateEFilingSubmitCheckbox = state => {
	let errors = [];

	if (state.data[EFILING_SUBMIT_CHECKBOX_FIELD] === false) {
		errors.push({
			errorMsg: REQUIRED_ERROR,
			fieldId: [EFILING_SUBMIT_CHECKBOX_FIELD]
		})
	}

	return errors;
}
